export default "__VITE_ASSET__d1adadb8__"